import { createApi, fetchBaseQuery, BaseQueryFn } from "@reduxjs/toolkit/query/react"
import config from "../config/config"
import { toast } from "react-toastify"
import { logoutState } from "src/shared/store/slices/auth/auth"

// Define types for the base query
interface BaseQueryArgs {
  url: string
  method?: string
  body?: any
  headers?: Record<string, string>
  params?: Record<string, any>
}

// Base query configuration for REST API
const baseQuery = fetchBaseQuery({
  baseUrl: config.tide.url, // This will be your REST API base URL
  prepareHeaders: (headers, { getState }) => {
    // Add authentication token if available
    console.log("token-getState()", getState())
    const token = (getState() as any)?.authentication?.token
    console.log("token", token)
    if (token) {
      headers.set("authorization", `Bearer ${token}`)
    }

    // Set content type for REST API
    headers.set("content-type", "application/json")
    headers.set("accept", "application/json")

    return headers
  }
})

// Base query with error handling and retry logic
const baseQueryWithReauth: BaseQueryFn<BaseQueryArgs> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)
  const resultStatus = result?.error?.status as number
  // Handle authentication errors
  if (result.error && "status" in result.error && resultStatus >= 400 && resultStatus < 500) {
    if (resultStatus === 401) {
      api.dispatch(logoutState())
      window.location.href = "/login"

      // Remove direct page reload and let the logout state change trigger navigation
    }
    toast.error((result?.error?.data as any)?.msg || "something went wrong")
  }

  // Handle server errors
  if (result.error && "status" in result.error && resultStatus >= 500) {
    toast.error("Something went wrong")
    console.error("Server error occurred:", result.error)
  }

  return result
}

// Create the base API slice
export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["User", "Vendor", "Utility", "Container", "Invoice"],
  endpoints: () => ({})
})

export default baseApi
